<template>
  <div :class="wrpCls">
    <header-search class="header-item" />
    <header-message class="header-item" />
    <div class="header-item">
      <a-icon type="download" @click="handleGoDownloadCenter" />
    </div>
    <div class="header-item">
      <!-- 全屏模式 -->
      <a-icon v-if="monitorFullScreen === 0" type="fullscreen" @click="toggleFullScreen" />
      <a-icon v-if="monitorFullScreen === 1" type="fullscreen-exit" @click="toggleFullScreen" />
    </div>
    <avatar-dropdown :menu="showMenu" :current-user="currentUser" :class="prefixCls" />
    <!--<select-lang :class="prefixCls" />-->
  </div>
</template>

<script>
import AvatarDropdown from './AvatarDropdown'
// import SelectLang from '@/components/SelectLang'
import { mapState } from 'vuex'
import HeaderSearch from './HeaderSearch'
import HeaderMessage from './HeaderMessage'
export default {
  name: 'RightContent',
  components: {
    AvatarDropdown,
    HeaderSearch,
    HeaderMessage
    // SelectLang
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ant-pro-global-header-index-action'
    },
    isMobile: {
      type: Boolean,
      default: () => false
    },
    topMenu: {
      type: Boolean,
      required: true
    },
    theme: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      showMenu: true,
      currentUser: {},
      monitorFullScreen: 0
    }
  },
  methods: {
    // 切换全屏图标
    // 全屏切换
    toggleFullScreen () {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen()
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        }
      }
      this.monitorFullScreen = this.monitorFullScreen === 0 ? 1 : 0
    },
    // 跳转到下载中心页
    handleGoDownloadCenter () {
      this.$router.push({ path: '/account/download' })
    }
  },
  computed: {
    wrpCls () {
      return {
        'top-line': true,
        'ant-pro-global-header-index-right': true,
        [`ant-pro-global-header-index-${(this.isMobile || !this.topMenu) ? 'light' : this.theme}`]: true
      }
    },
    ...mapState({
      name: (state) => state.user.name,
      avatar: (state) => state.avatar
    })
  },
  mounted () {
    setTimeout(() => {
      this.currentUser = {
        name: this.name
      }
    }, 1500)
  }
}
</script>

<style lang="less" scoped>
.top-line{
  display: flex;
  align-items: center;
}
.header-item{
  color: inherit;
  padding: 0 10px;
  cursor: pointer;
  align-self: center;
  a{
    color: inherit;
    i{
      font-size: 16px;
    }
  }
  &:hover{
    background-color: rgba(0,0,0,.025);
  }
}
</style>
